export default __webpack_public_path__ + "static/media/edit.693dafcd.svg";